<ng-container *ngIf="cargando">
    <div fxLayout="column" fxLayoutAlign="space-between center">
        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
        <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
    </div>
</ng-container>

<ng-container *ngIf="!statusDoctor && !cargando">
    <div class="statusDiv" fxLayout="row" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}" style="margin-top: 30px;">
        <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
            <h2>{{'WIZARD.ALERT.LABEL01' | translate}}</h2>
            <mat-icon class="ml-20 s-40">error_outline</mat-icon>
        </div>
    </div>

</ng-container>

<ng-container *ngIf="statusDoctor && !cargando">

    <div fxLayout="column" fxLayoutAlign="space-around stretch">
        <mat-form-field appearance="outline">
            <mat-label>{{'WIZARD.SEARCH' | translate}}</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Filter">
            <mat-icon matSuffix class="disabled-text">search</mat-icon>
        </mat-form-field>

    </div>

    <div fxLayout="column" fxLayoutAlign="start stretch">
        <mat-table class="mat-elevation-z3 p-20" [dataSource]="dataSource" [@animateStagger]="{value:'50'}" style="margin-top: 15px;" fxFlex="83">

            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef>
                    <h2><b class="word">{{'WIZARD.DATOSDOCTORES.PANEL.LABEL01' | translate}}</b></h2>
                </mat-header-cell>
                <mat-cell *matCellDef="let filaArch;let idxDescr = index;" style="padding-right: 25px;">
                    <ng-container>
                        {{filaArch.nombre}}
                    </ng-container>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="workcenter">

                <mat-header-cell *matHeaderCellDef>
                    <h2><b class="word">{{'WIZARD.DATOSDOCTORES.PANEL.LABEL05' | translate}}</b></h2>
                </mat-header-cell>
                <mat-cell *matCellDef="let filaArch;let idxDescr = index;">
                    <ng-container>
                        {{filaArch.nombreCT}}
                    </ng-container>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="correo">
                <mat-header-cell *matHeaderCellDef>
                    <h2><b class="word">{{'WIZARD.DATOSDOCTORES.PANEL.LABEL02' | translate}}</b></h2>
                </mat-header-cell>
                <mat-cell *matCellDef="let filaArch;let idxDescr = index;">
                    <ng-container>
                        {{filaArch.correo}}
                    </ng-container>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="telefono">
                <mat-header-cell *matHeaderCellDef>
                    <h2><b class="word">{{'WIZARD.DATOSDOCTORES.PANEL.LABEL07' | translate}}</b></h2>
                </mat-header-cell>
                <mat-cell *matCellDef="let filaArch;let idxDescr = index;">
                    <ng-container>
                        {{filaArch.telefono}}
                    </ng-container>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="clave">
                <mat-header-cell *matHeaderCellDef>
                    <h2><b>{{'WIZARD.DATOSDOCTORES.PANEL.LABEL08' | translate}}</b></h2>
                </mat-header-cell>
                <mat-cell *matCellDef="let filaArch;let idxDescr = index;">
                    <ng-container>
                        <!--{{claves[idxDescr]._id}}-->
                        <button mat-raised-button class="mb-20" (click)="copyMessage(idxDescr)" value="click to copy">
                            {{'WIZARD.DATOSDOCTORES.PANEL.LABEL11' | translate}
                            <mat-icon class="ml-20 ">vpn_key</mat-icon>
                        </button>
                    </ng-container>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="acciones">
                <mat-header-cell *matHeaderCellDef>
                    <h2><b class="word">{{'WIZARD.DATOSDOCTORES.PANEL.LABEL10' | translate}}</b></h2>
                </mat-header-cell>
                <mat-cell *matCellDef="let filaArch">
                    <ng-container>
                        <button mat-icon-button aria-label="" (click)="deleteDoc(filaArch._id)">
                            <mat-icon matTooltip="{{'WIZARD.DATOSDOCTORES.PANEL.LABEL09' | translate}}" style="font-size: 30px; color: #F50000;">delete</mat-icon>
                        </button>
                        <!--<p mat-line>{{'WIZARD.DATOSDOCTORES.PANEL.LABEL09' | translate}}</p>-->
                        <button mat-icon-button aria-label="" (click)="openDialog(filaArch._id)">
                            <mat-icon matTooltip="Citas" style="font-size: 30px; color: #F50000;">assignment_turned_in</mat-icon>
                        </button>
                    </ng-container>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="nombresColumnasheader"></mat-header-row>
            <mat-row *matRowDef="let filaArch; columns: nombresColumnasCont;" matRipple [@animate]="{value:'*',params:{y:'100%'}}">
            </mat-row>
        </mat-table>

    </div>


</ng-container>